import { mappings } from './gridMappings';
import Image from 'next/image';

const SectionKeypoints = () => {
  return (
    <div className="container">
      <div className="md:tw-grid md:tw-grid-cols-5 tw-gap-12 tw-py-12">
        <div className="md:tw-col-span-2">
          <h3
            className="tw-font-bold tw-text-4xl tw-pb-2 tw-tracking-tighter tw-text-gray-800"
          >
            Winelivery ist das führende Unternehmen in Italien mit über 60 Tochtergesellschaften
          </h3>
        </div>
        <div className="md:tw-col-span-3 md:tw-pl-12">
          <div className="tw-grid tw-grid-cols-2 tw-gap-10">
            {[0, 1, 2, 3].map((num) => (
              <div>
                <div className="tw-w-20 tw-h-20 position-relative">
                  <Image
                    fill style={{objectFit: 'contain'}}
                    src={mappings[num].img}
                    alt={mappings[num].title}
                  />
                </div>
                <div className="tw-mt-2">
                  <div className="tw-text-lg tw-font-medium tw-tracking-tighter tw-text-gray-500">
                    {mappings[num].content}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionKeypoints;
